module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_8.f6ca4b38.png";